import React, { useState } from "react";
import Contact from "../Contact/Contact";
import Footer from "../Footer/Footer";
import Landing from "../Landing/Landing";
import Navbar from "../NavBar/Navbar";
import NavbarMenu from "../NavbarMenu/NavbarMenu";
import SideBar from "../SideBar/SideBar";
import "./Content.css";
import "./Achievement.css"
import achTopIcon from "../../image/newImg/ach.png";
import award_1 from "../../image/award/award_1.jpg";
import award_2 from "../../image/award/award_2.jpg";
import award_3 from "../../image/award/award_3.jpg";
import award_4 from "../../image/award/award_4.jpg";
import award_5 from "../../image/award/award_5.jpg";
import award_6 from "../../image/award/award_6.jpg";
import award7 from "../../image/award/Achievement.jpg";
import award8 from "../../image/award/Career 360 award.jpg";
import award9 from "../../image/award/Education Today Award.jpg";
import award10 from "../../image/award/education world award.jpg";

import award1 from "../../image/award/International Hindi Olympiad 2025.jpg";
import award2 from "../../image/award/Inspire MANAK.jpg";
import award3 from "../../image/award/Olympiad Foundation (IOF) Results.jpg";
import award4 from "../../image/award/State League Jury Winner.jpg";
import award5 from "../../image/award/International Hindi Olympiad 2025.jpg";
import award6 from "../../image/award/Innoventure 2025-26.png";
import orator from "../../image/award/orator.webp";
import achivers2025 from "../../image/award/Achievers 2025.webp";
import Taekwondo from "../../image/award/Taekwondo Championship.jpg";
import ReyanshJoshi from "../../image/award/ReyanshJoshi.webp";
import proud from "../../image/award/proudmomet.webp";
import swimming from "../../image/award/Sakshi Belwal's.webp";
import smayak from "../../image/award/Samayak.webp";
import aryabhatta from "../../image/award/aryabhatta.webp";
import ukopenstate from "../../image/award/ukopenstate.webp";
// Placeholder images: replace these paths when the actual images are available.
import hackathonImage from "../../image/award/Inter-School Hackathon Achievement 1.webp";
import danceSingingImage from "../../image/award/Achievement.jpg";
import educationTodayFeatureImage from "../../image/award/best-school-in-north.webp";

import achievmentsimg from "../../image/award/Achievement.jpg";
import { Col, Row } from "react-bootstrap";
import Slider from "react-slick";



function Achievements(props) {
  const { cover, sidebar_data, side_heading, side_sub_heading } = props;
  const [isScrolled, setIsScrolled] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    autoplay: true,
    autoplaySpeed: 2500,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1
  };
  const handleScroll = (e) => {
    if (e.target.scrollTop > 0 && !isScrolled) {
      setIsScrolled(true);
    } else if (e.target.scrollTop === 0) {
      setIsScrolled(false);
    }
  };

  const handleClick = () => {
    setIsShow(!isShow);
  };

  const images = [
    award_1,
    award_2,
    award_3,
    award_4,
    award_5,
    award_6,
    award7,
    award8,
    award9,
    award10,
  ];

  return (
    <div className="content_main" onScroll={handleScroll}>
      <Navbar isScrolled={isScrolled} handleClick={handleClick} />
      <NavbarMenu isShow={isShow} handleClick={handleClick} />
      <Landing video={false} cover={cover} />
      <div className="contentmain_cont">
        <div className="sidebar_container">
          <SideBar
            sidebar_data={sidebar_data}
            side_heading={side_heading}
            side_sub_heading={side_sub_heading}
          />
          <Contact />
        </div>
        <div className="main_content">
          <div className="content-start">
            <h1>Achievements & Laurels</h1>
          </div>
          <div className="intro">
            <p className="intro_text">
              "The harder you work for something, the greater you'll feel when you achieve it." It is a jubilant & ecstatic moment for Herman Gmeiner School to announce that our school has been nominated for the Global Awards for its astounding innovation in Pedagogy.
            </p>

            {/* Inter School Hackathon Competition - September 2026 */}
            <div className="achievement_section">
              <div className="achievement_content">
                <div className="col-lg-6 achieveimage">
                  <img height={450} src={hackathonImage} alt="Inter School Hackathon Competition 2026" className="awardImage" />
                </div>
                <div className="col-lg-6 achiecontent">
                  <h2 className="section_titless">Hackathon Competition 2026</h2>
                  <p>
                    St. Joseph College, Nainital organized an Inter School Hackathon Competition on <strong>28 and 29 September 2026</strong>.
                    A total of 12 schools participated, and the HGS Bhimtal team secured <strong>1st position</strong>.
                  </p>
                  <p><strong>Winning team:</strong></p>
                  <ol>
                    <li>Kanishk Gupta</li>
                    <li>Mohd. Rehan</li>
                    <li>Prayag Yadav</li>
                    <li>Nishchal Singh Jalal</li>
                  </ol>
                </div>
              </div>
            </div>

            {/* Inter School Dance and Singing Competition - September 2026 */}
            <div className="achievement_section">
              <div className="achievement_content">
                <div className="col-lg-6 achiecontent">
                  <h2 className="section_titless">Inter School Dance &amp; Singing Competition</h2>
                  <p>
                    On the occasion of Nandastami Mahotsava, the Nanda Devi Committee organized an Inter School Dance and Singing Competition on <strong>19 September 2026</strong>.
                    Students from HGS Bhimtal participated and secured <strong>2nd position in both events</strong>.
                  </p>
                  <p><strong>Dance participants:</strong></p>
                  <ol>
                    <li>Sajag Alive (Class VIII A)</li>
                    <li>Kaina Kakkar (Class VIII A)</li>
                    <li>Kritya Mamgain (Class VIII A)</li>
                    <li>Sparsh (Class VIII A)</li>
                    <li>Kavya Bisht (Class VIII A)</li>
                    <li>Garvit (Class VIII A)</li>
                    <li>Bhavya (Class VIII A)</li>
                    <li>Garima (Class VIII A)</li>
                    <li>Ishika (Class VIII A)</li>
                    <li>Gajendra Pratap Singh (Class VIII A)</li>
                  </ol>
                  <p><strong>Singing participants:</strong></p>
                  <ol>
                    <li>Manasvi Joshi (Class XI)</li>
                    <li>Priya Negi (Class XI)</li>
                    <li>Nidhi Karki (Class XI)</li>
                    <li>Lavanya Joshi (Class XI)</li>
                    <li>Kriti Upreti (Class XI)</li>
                    <li>Geeta Rathore (Class XI A)</li>
                    <li>Tanya Bhagat (Class XI A)</li>
                    <li>Gayatri (Class XI A)</li>
                    <li>Suhana (Class X C)</li>
                    <li>Paridhi Nainwal (Class X B)</li>
                    <li>Siddharth Arya (Class X A)</li>
                    <li>Harsh Bisht (Class X B)</li>
                    <li>Madhav Vashisth (Class VII B)</li>
                  </ol>
                </div>
                <div className="col-lg-6 achieveimage">
                  {/* <img height={450} src={danceSingingImage} alt="Inter School Dance and Singing Competition 2026" className="awardImage" /> */}
                </div>
              </div>
            </div>

            {/* Education Today Feature - August 2026 */}
            <div className="achievement_section">
              <div className="achievement_content">
                <div className="col-lg-6 achieveimage">
                  <img height={450} src={educationTodayFeatureImage} alt="HGS Bhimtal featured in Education Today" className="awardImage" />
                </div>
                <div className="col-lg-6 achiecontent">
                  <h2 className="section_titless">HGS Bhimtal Featured in Education Today</h2>
                  <p><strong>August 2026</strong></p>
                  <p>
                    We are proud to announce that our journey of transforming education has been showcased in the latest edition of Education Today.
                    <br /><br />
                    Our feature explores how HGS is creating an ecosystem where students don't just learn—they experience, innovate, and grow through real-world learning, mentorship, and holistic development.
                  </p>
                </div>
              </div>
            </div>

            {/* Aryabhatta National Maths Competition 2026 */}
            <div className="achievement_section">
              <div className="achievement_content">
                <div className="col-lg-6 achieveimage">
                    <img height={450} src={aryabhatta} alt="Aryabhatta National Maths Competition 2026" className="awardImage" />
                </div>
                <div className="col-lg-6 achiecontent">
                  <h2 className="section_titless">A Proud Achievement for HGS Bhimtal! 🌟</h2>
                  <p>
                    Heartiest congratulations to Ishanvi Mahapatra for securing a perfect <strong>100% score</strong> in Round 1 of the Aryabhatta National Maths Competition – 2026. 🏆📚
                    <br /><br />
                    Your dedication, hard work and passion for learning have brought great pride to the HGS Bhimtal family. We are delighted to celebrate this wonderful achievement and wish you continued success in all your future endeavours! ✨
                    <br /><br />
                    Keep learning, keep shining and keep reaching greater heights! 🌟
                  </p>
                </div>
              </div>
            </div>

            {/* Uttarakhand Open State Karate Championship */}
            <div className="achievement_section">
              <div className="achievement_content">
                <div className="col-lg-6 achiecontent">
                  <h2 className="section_titless">Congratulations!</h2>
                  <p>
                    We are thrilled to announce the success of the 9th edition of the Uttarakhand Open State Karate Championship, organized by the Shotokan Karate International Association of India (SIKAI). This year's championship witnessed participation from various teams, showcasing incredible talent and sportsmanship.
                    <br /><br />
                    We extend our heartfelt congratulations to our student, <strong>Gajender Pratap Bishno</strong>, for his outstanding achievements! Gajender won two gold medals—one in kumite (fight) and another in kata (show/category). His dedication and hard work truly shone through in both competitions.
                    <br /><br />
                    In addition to his impressive performances, Gajender also showcased his expertise by serving as a referee during the event, exemplifying his commitment to the sport and the karate community.
                    <br /><br />
                    Congratulations again to Gajender and all the participants for their remarkable achievements!
                  </p>
                </div>
                <div className="col-lg-6 achieveimage">
                  <img height={450} src={ukopenstate} alt="Uttarakhand Open State Karate Championship" className="awardImage" />
                </div>
              </div>
            </div>

            {/* State Level Open Swimming Competition */}
            <div className="achievement_section">
              <div className="achievement_content">
                <div className="col-lg-6 achieveimage">
                  <img height={450} src={swimming} alt="State Level Open Swimming Competition" className="awardImage" />
                </div>
                <div className="col-lg-6 achiecontent">
                  <h2 className="section_titless">State Level Open Swimming Competition</h2>
                  <p>
                    We are delighted to announce the outstanding performance of Sakshi Belwal from Grade 8B of HGS Bhimtal at the state-level open swimming competition organized by Swim for Glory, held at the Haldwani Unchapul Fun City Club on July 5, 2026.
                    <br /><br />
                    <strong>Achievements:</strong>
                    <br />Event 1: Backstroke Under 14
                    <br />Result: 2nd Position (Silver Medal)
                    <br />Event 2: Under 14 Relay
                    <br />Result: 2nd Position (Silver Medal)
                    <br /><br />
                    Congratulations, Sakshi, on your impressive achievements! Your hard work and commitment to swimming are truly inspiring!
                  </p>
                </div>
              </div>
            </div>

            {/* JEE Advanced 2026 Achievement */}
            <div className="achievement_section">
              <div className="achievement_content">
                <div className="col-lg-6 achiecontent">
                  <h2 className="section_titless">JEE Advanced 2026 Achievement</h2>
                  <p>
                    We are immensely proud to share that our student, Samyak Gaur, has cleared JEE Advanced 2026, securing an All India Rank (AIR) of 3136!
                    <br /><br />
                    He is set to take his place in a top IIT of the country. What makes this achievement even more historic is that Samyak is the only student from Bhimtal to qualify for JEE Advanced this year. HGS Bhimtal is incredibly proud of him for putting our town on the map!
                  </p>
                </div>
                <div className="col-lg-6 achieveimage">
                  <img height={450} src={smayak} alt="JEE Advanced 2026 Achievement" className="awardImage" />
                </div>
              </div>
            </div>



            {/* Proud Moment of Achievement*/}
            <div className="achievement_section">
              <div className="achievement_content">
                <div className="col-lg-6 achieveimage">
                  <img height={450} src={ReyanshJoshi} alt="Proud Moment of Achievement" className="awardImage" />
                </div>
                <div className="col-lg-6 achiecontent">
                  <h2 className="section_titless">Proud Moment of Achievement! </h2>
                  <p>
                    Heartiest congratulations to Reyaansh Joshi of Class PREP for winning the SILVER MEDAL in the Taekwondo Championship held in Haldwani.
                    <br />Your dedication, courage, and fighting spirit at such a young age are truly inspiring. We are immensely proud of your remarkable achievement and wish you many more victories ahead!
                    <br />Keep believing, keep achieving!
                  </p>
                </div>
              </div>
            </div>

            {/* Proud Achievement Alert! */}
            <div className="achievement_section">
              <div className="achievement_content">
                <div className="col-lg-6 achiecontent">
                  <h2 className="section_titless">Proud Achievement Alert!</h2>
                  <p>
                    Heartiest congratulations to Hridyansh Khulbe (Class 3) for winning the Bronze Medal at the Open National Taekwondo Championship!
                    <br />His hard work, dedication, and determination have brought pride to HGS Bhimtal.
                    <br />Keep shining, keep striving, and keep inspiring!
                  </p>
                </div>
                <div className="col-lg-6 achieveimage">
                  <img height={450} src={Taekwondo} alt="Proud Achievement Alert" className="awardImage" />
                </div>
              </div>
            </div>

            {/* Proud Moment for HGS Bhimtal */}
            <div className="achievement_section">
              <div className="achievement_content">
                <div className="col-lg-6 achieveimage">
                  <img src={proud} alt="Proud Moment for HGS Bhimtal" className="awardImage" />
                </div>
                <div className="col-lg-6 achiecontent">
                  <h2 className="section_titless">Proud Moment for HGS Bhimtal</h2>
                  <p>
                    Heartiest Congratulations to our CBSE Class XII Topper for achieving outstanding academic excellence!
                    Your hard work, dedication, perseverance, and commitment have brought immense pride to the entire HGS family. This remarkable achievement is a reflection of your determination and the constant support of your teachers and parents.
                    May this success be the beginning of many greater accomplishments in the future. Keep shining and inspiring others!
                    Congratulations once again on this well-deserved success!
                  </p>
                </div>
              </div>
            </div>


            {/* Congratulations to Our Achievers! */}
            <div className="achievement_section">
              <div className="achievement_content">
                <div className="col-lg-6 achiecontent">
                  <h2 className="section_titless">Congratulations to Our Achievers!</h2>
                  <p>
                    We extend our heartfelt congratulations to all the students for their exceptional performance in the X Board exams! Your hard work and dedication have truly paid off, making us all proud.
                    With the unwavering support and encouragement from our HGS Bhimtal community, we have once again achieved remarkable results. We are thrilled to announce that 34 students scored 90% or higher, with our school topper achieving an outstanding 98%!
                    Thank you for your continuous support, which has played a vital role in their success. Your belief in our students inspires them to strive for excellence.
                    Here's to more successes in the future
                  </p>
                </div>
                <div className="col-lg-6 achieveimage">
                  <img src={achivers2025} alt="Congratulations to Our Achievers" className="awardImage" />
                </div>
              </div>
            </div>

            {/* Orator of the Year competition */}
            <div className="achievement_section">
              <div className="achievement_content">
                <div className="col-lg-6 achieveimage">
                  <img src={orator} alt="Orator of the Year competition" className="awardImage" />
                </div>
                <div className="col-lg-6 achiecontent">
                  <h2 className="section_titless">Orator of the Year competition</h2>
                  <p>
                    We are thrilled to announce that our school has been awarded a Certificate of Appreciation for securing the runner-up position in the 12th LPS–P B Pande Orator of the Year competition held on April 28, 2026!
                    This remarkable achievement highlights the hard work and dedication of our students, along with the continuous support and guidance provided by our dedicated faculty. With nearly 40 participants from top schools in Nainital and Haldwani, our talented girl truly made her presence felt on that prestigious stage.
                    Congratulations to our orator Mahira Hussain of grade X .
                  </p>
                </div>
              </div>
            </div>

            {/* School’s Achievements */}
            <div className="achievement_section">
              <div className="achievement_content">
                <div className="col-lg-6 achiecontent">
                  <h2 className="section_titless">School’s Achievements</h2>
                  <p>Take pride in how far we have come and have faith in how far we can go. Congratulations are in order!! A proud moment for HGS as the school has once again been awarded, and this time RANKED No. 1 IN NAINITAL With a Certificate of Achievement in "INDIA’S TOP DAY CUM BOARDING SCHOOL”, by Education Today. This award brings honor and opens the door to more success in the future. This is a much-deserved award for a school that believes in consistent hard work and pursues excellence. It is inspirational to witness hard work giving birth to success. The school has been recognized with such a prestigious award through the combined efforts of the teachers and students. May we keep climbing new heights of success!</p>
                </div>
                <div className="col-lg-6 achieveimage">
                  <img src={award7} alt="Award" className="awardImage" />
                </div>
              </div>
            </div>

            {/* International Hindi Olympiad 2025 */}
            <div className="achievement_section">
              <div className="achievement_content">
                <div className="col-lg-6 achieveimage">
                  <img src={award1} alt="Hindi Olympiad" className="awardImage" />
                </div>
                <div className="col-lg-6 achiecontent">
                  <h2 className="section_titless">International Hindi Olympiad 2025</h2>
                  <p>
                    The International Hindi Olympiad 2025 was organized by Hindi Vikas Sansthan, Delhi at HGS Bhimtal on October 15, 2025.
                    A total of 35 students from Classes 1 to 12 participated in the competition.
                    <br /><br />
                    The Olympiad aimed to encourage students to improve their Hindi language skills and give them a platform to show their talent.
                    Students took part with great enthusiasm and confidence, displaying their strong understanding of the language.
                    <br /><br />
                    Thirteen students won awards, including 8 Gold Medals, 3 Silver Medals, and 2 Bronze Medals.
                    The event highlighted the importance of the Hindi language and culture and inspired students to continue learning and promoting it.
                  </p>
                </div>
              </div>
            </div>

            {/* Inspire MANAK */}
            <div className="achievement_section">
              <div className="achievement_content">
                <div className="col-lg-6 achiecontent">
                  <h2 className="section_titless">Inspire MANAK</h2>
                  <p>
                    With great pride we would like to share that Yugal Kishore Sanwal's idea for the Inspire MANAK Award
                    has been selected from District Nainital to participate at the State Level Exhibition.
                  </p>
                </div>
                <div className="col-lg-6 achieveimage">
                  <img src={award2} alt="Inspire Manak" className="awardImage" />
                </div>
              </div>
            </div>

            {/* Olympiad Foundation Results */}
            <div className="achievement_section">
              <div className="achievement_content">
                <div className="col-lg-6 achieveimage">
                  <img src={award3} alt="Olympiad Foundation" className="awardImage" />
                </div>
                <div className="col-lg-6 achiecontent">
                  <h2 className="section_titless">Olympiad Foundation (IOF) Results</h2>
                  <p>
                    We are thrilled to share the amazing results our students achieved at the Olympiad Foundation (IOF).
                    <br /><br />
                    <strong>Highlights:</strong>
                    <br />1 International Topper
                    <br />5 Zonal Toppers
                    <br />3 Gold Medals
                    <br />11 Silver Medals
                    <br />9 Bronze Medals
                  </p>
                </div>
              </div>
            </div>

            {/* State League Jury Winner */}
            <div className="achievement_section">
              <div className="achievement_content">
                <div className="col-lg-6 achiecontent">
                  <h2 className="section_titless">State League Jury Winner</h2>
                  <p>
                    Amogh Naugain of Grade 1 won the State League Jury Winner Medal at SBWF 2025 for his book
                    <strong> “Zooby’s Space Adventure”</strong>, published by Bri Books.
                    <br /><br />
                    The book is proudly ranked <strong>No. 8 in Uttarakhand</strong>, making this a remarkable achievement
                    for such a young author.
                  </p>
                </div>
                <div className="col-lg-6 achieveimage">
                  <img src={award4} alt="State League Winner" className="awardImage" />
                </div>
              </div>
            </div>

            {/* International Hindi Olympiad Medalists */}
            <div className="achievement_section">
              <div className="achievement_content">
                <div className="col-lg-6 achieveimage">
                  <img src={award5} alt="Hindi Olympiad Medals" className="awardImage" />
                </div>
                <div className="col-lg-6 achiecontent">
                  <h2 className="section_titless">International Hindi Olympiad</h2>
                  <p>
                    13 students of HGS, Bhimtal earned medals at the International Hindi Olympiad organized by
                    Hindi Vikas Sansthan, Delhi.
                    <br /><br />
                    The school acquired <strong>8 Gold Medals, 3 Silver Medals, and 3 Bronze Medals</strong>.
                  </p>
                </div>
              </div>
            </div>

            {/* Innoventure */}
            <div className="achievement_section">
              <div className="achievement_content">
                <div className="col-lg-6 achiecontent">
                  <h2 className="section_titless">Innoventure 2025-26</h2>
                  <p>
                    Ishanvi Mohapatra has been awarded the <strong>Certificate of Merit</strong> in the Innoventure 2025-26 challenge,
                    India’s largest ideation and innovation initiative for school children.
                    <br /><br />
                    The event was organized by Innoventure World Foundation (Intelligence Plus) in collaboration
                    with <strong>E-Cell, IIT Hyderabad</strong>.
                  </p>
                </div>
                <div className="col-lg-6 achieveimage">
                  <img src={award6} alt="Innoventure" className="awardImage" />
                </div>
              </div>
            </div>

            {/* Ideathon */}
            <div className="achievement_section">
              <div className="achievement_content">
                <div className="col-lg-6 achieveimage">
                  <img src={award7} alt="Ideathon" className="awardImage" />
                </div>
                <div className="col-lg-6 achiecontent">
                  <h2 className="section_titless">Celebrating Innovation at Ideathon 2025</h2>
                  <p>
                    Three teams from HGS, Bhimtal have made it to the <strong>Top 2000 of Ideathon 2025</strong>.
                    <br /><br />
                    Congratulations to our selected teams:
                    <br />1. Kanishk Gupta & Anamika (Class XI-B)
                    <br />2. Pratishtha (Class XI-C)
                    <br />3. Purvansh Joshi & Yug Chandra (Class XII-C)
                  </p>
                </div>
              </div>
            </div>

            {/* Best Seller Author */}
            <div className="achievement_section">
              <div className="achievement_content">
                <div className="col-lg-6 achiecontent">
                  <h2 className="section_titless">State Best Seller Author</h2>
                  <p>
                    HGS Bhimtal proudly celebrates <strong>Bhavika Mamgain</strong> of Class IX on being recognized as a
                    <strong> BRI BOOK State Best Seller Author</strong>.
                  </p>
                </div>
                <div className="col-lg-6 achieveimage">
                  <img src={award8} alt="Best Seller Author" className="awardImage" />
                </div>
              </div>
            </div>

            {/* Certificate of Merit */}
            <div className="achievement_section">
              <div className="achievement_content">
                <div className="col-lg-6 achieveimage">
                  <img src={award9} alt="Certificate of Merit" className="awardImage" />
                </div>
                <div className="col-lg-6 achiecontent">
                  <h2 className="section_titless">Certificate of Merit</h2>
                  <p>
                    Arshma Ansari and Sakshi received the Certificate of Merit at St Joseph College, Nainital,
                    for their outstanding face painting skills showcased at Literati on October 11, 2025.
                    <br /><br />
                    Their creativity and attention to detail made their work stand out among many participants.
                    The event highlighted their artistic ability and boosted their confidence and motivation.
                    <br /><br />
                    Through such competitions, students develop important skills like focus, patience, and self-expression,
                    contributing to their overall growth.
                  </p>
                </div>
              </div>
            </div>



            <div className="container py-4 silderac">
              <h2 className="fw-bold text-center mb-4">Awards Gallery</h2>

              <Slider {...settings}>
                {images.map((img, i) => (
                  <div key={i} className="img-slide-wrapper">
                    <img src={img} alt="gallery" className="slider-img" />
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Achievements;

